import request from '@/utils/request'

export function epmsa340(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa340/epmsa340`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsa340Xls(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa340/epmsa340Xls`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {
   
    const binaryString = window.atob(res.body)
    const binaryLen = binaryString.length
    let bytes = new Uint8Array(binaryLen)
    
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i)
      bytes[i] = ascii
    }
    
    const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
    const blobURL = URL.createObjectURL(blob)

    const link = document.createElement('a');
    link.href = blobURL;
    link.download = `Outsourcing Block POR Follow Up.xls`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  })
}

